import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastReusable } from '../../../../libs/core/shared/ui/toast-reusable/toast-reusable';

@Component({
  imports: [RouterModule, ToastReusable],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected title = 'superadmin';
}
